import { render, staticRenderFns } from "./view-token-layout.vue?vue&type=template&id=865ce6d0"
import script from "./view-token-layout.vue?vue&type=script&lang=js"
export * from "./view-token-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports